module.exports = __webpack_public_path__ + "img/img_home_warehouse_5.a681b94c.png";